import apiClient from "../api/apiClient"
import { Bill, PaginatedResponse } from "../../types"

export const billService = {
  async getBills(params?: {
    page?: number
    limit?: number
    customer_name?: string
    customer_id?: string
    status?: string
    payment_status?: string
    booker_id?: string
    area?: string
    date?: string
  }): Promise<PaginatedResponse<Bill>> {
    const response = await apiClient.get<{
      info: {
        page: number
        limit: number
        total: number
        totalPages: number
        hasNextPage: boolean
      }
      results: Bill[]
    }>("/admin/billing/get-all", { params })
    
    // Transform API response to match PaginatedResponse interface
    return {
      data: response.data.results,
      total: response.data.info.total,
      page: response.data.info.page,
      limit: response.data.info.limit,
      totalPages: response.data.info.totalPages,
    }
  },

  async getBillById(id: string): Promise<Bill> {
    const response = await apiClient.get<Bill>(`/admin/billing/${id}`)
    return response.data
  },

  async updateBill(id: string, billData: any): Promise<Bill> {
    const response = await apiClient.put<Bill>(`/admin/billing/${id}`, billData)
    return response.data
  },

  async deleteBill(id: string): Promise<void> {
    await apiClient.delete(`/admin/billing/${id}`)
  },

  async cancelBill(id: string): Promise<Bill> {
    const response = await apiClient.patch<Bill>(`/admin/billing/${id}/cancel`)
    return response.data
  },

  async createBill(data: {
    customer_id: string
    sku_items: { sku_id: string; quantity_ctn: number; loose_pcs?: number }[]
    remarks?: string
  }): Promise<Bill> {
    const response = await apiClient.post<{ message: string; bill: Bill }>('/admin/billing/create', data)
    return response.data.bill
  },

  async printBillHtml(id: string): Promise<string> {
    const response = await apiClient.get<string>(`/admin/billing/${id}/print-html`)
    return response.data
  },
}
